module.exports = __webpack_public_path__ + "static/media/xlsm.f16892e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/xlsm.svg
// module id = 1676
// module chunks = 17